import NewBookingFormInfantRow from './NewBookingFormInfantRow'

export default NewBookingFormInfantRow
